<template>
  <tr :class="line.reconciliation ? 'green lighten-5' : ''">
    <td>
      {{ line.date | shortDate }}
      <span v-if='line.is_expense'> -- {{ line.expense.purchased_at }}</span>
      <v-tooltip right v-if='line.is_deposit && line.deposit.is_credit_card'>
        <template v-slot:activator='{ on }'>
          <v-icon
            :color='$store.state.icons.dataBox.creditCards.iconColor'
            class='ml-4'
            v-on='on'
          >
            {{ $store.state.icons.dataBox.creditCards.icon }}
          </v-icon>
        </template>
        <span>
          Credit card batch
        </span>
      </v-tooltip>
    </td>
    <td align='right'><span v-if='line.is_expense'>{{ line.expense_amount | dec }}</span></td>
    <td align='right'><span v-if='line.is_deposit'>{{ line.deposit_amount | dec }}</span></td>
    <td class='text-right'>
      <wc-checkbox
        :disabled='rec.is_locked'
        :status='line.reconciliation !== null'
        :isLoading='isLoading'
        @toggle='toggleInclusion'
      ></wc-checkbox>
    </td>
    <td class='text-left'>
      <v-btn icon @click='openLineItem(line)'>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </td>
  </tr>

</template>

<script>
import WCCheckbox from '@/components/forms/WCCheckbox';
import accountingAPI from '@/api/accounting';
import miscServices from '@/services/misc';
import _ from 'lodash';

export default {
  name: 'rec-line',
  props: {
    rec: {
      required: true
    },
    line: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    lineCopy: {}
  }),
  methods: {
    async toggleInclusion () {
      if (this.rec.is_locked === false) {
        this.isLoading = true
        this.lineCopy = _.cloneDeep(this.line)

        // Update the various reconciliation values to either null, or the rec.id
        // Have to determine if the line is a deposit of an expense, and set fields accordingly
        if (this.lineCopy.reconciliation) {
          // If it's currently reconciled, then we undo that, setting it to null
          this.lineCopy.reconciliation = null
          this.lineCopy.is_deposit ? this.lineCopy.deposit.reconciliation = null : this.lineCopy.expense.reconciliation = null
        } else {
          this.lineCopy.reconciliation = this.rec.id
          this.lineCopy.is_deposit ? this.lineCopy.deposit.reconciliation = this.rec.id : this.lineCopy.expense.reconciliation = this.rec.id
        }

        // Now update the line
        if (this.lineCopy.is_deposit) {
          this.lineCopy.deposit = await accountingAPI.updateDeposit(this.lineCopy.deposit.id, this.lineCopy.deposit)
        } else {
          this.lineCopy.expense = await accountingAPI.updateExpense(this.lineCopy.expense.id, this.lineCopy.expense)
        }

        // Send the updated line back up to the reconciliation
        this.$emit('updateLine', this.lineCopy)
        this.isLoading = false
      }
    },
    openLineItem (line) {
      if (line.is_deposit && line.deposit.is_credit_card) {
        miscServices.openInNewTab({ name: 'CreditCardBatch', params: { id: line.deposit.id } })
      }
      if (line.is_deposit && !line.deposit.is_credit_card) {
        miscServices.openInNewTab({ name: 'DepositDetail', params: { id: line.deposit.id } })
      }
      if (line.is_expense) {
        miscServices.openInNewTab({ name: 'ExpenseOverview', params: { id: line.expense.id } })
      }
    }
  },
  components: {
    'wc-checkbox': WCCheckbox
  }
}
</script>
